export default {
      id: "ic_minus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "images/icons.3.109.2.svg#ic_minus-usage",
      toString: function () {
        return this.url;
      }
    }